import React, { useState } from "react";
import HeroSection from "./components/HeroSection";
import HoverCard from "./components/HoverCard";
import WhyChooseUs from "./components/WhyChooseUs";
import NftCard from "components/card/NftCard";
import NFt3 from "assets/img/nfts/Nft3.png";
import Bg_Image from "assets/img/frontend/hero_section_2.jpg";
import Testimonial from "./components/Testimonial";
import FooterFrontend from "components/footer/FooterFrontend";

const Home = () => {
  const tickets = new Array(12).fill({
    title: "Ticket Title",
    assigned_to: "Unknown User",
    status: "Status",
    image: NFt3,
    created_at: "Date Not Available",
  });

  const [visibleCount, setVisibleCount] = useState(() => {
    if (window.innerWidth < 768) return 3; // sm and below
    if (window.innerWidth > 1600) return 8; // md and above (2 rows if 3 per row)
    return 6; // md and above (2 rows if 3 per row)
  });

  const handleViewMore = () => {
    if (window.innerWidth < 768) {
      setVisibleCount((prev) => prev + 3);
    } else if (window.innerWidth > 1600) {
      setVisibleCount((prev) => prev + 4);
    } else {
      setVisibleCount((prev) => prev + 3); // next row of 3 cards
    }
  };
  return (
    <>
      <HeroSection />
      <div className="px-4 py-8 md:px-8 lg:px-16 xl:px-24">
        {/* Upper section with title and text */}
        <div className="mb-8 space-y-4 text-left md:text-left">
          <div className="flex items-center justify-start text-xl font-semibold text-gray-800">
            <span className="mr-2 inline-block h-5 w-5 rounded-full bg-yellow-500"></span>
            Top Destinations
          </div>

          <h2 className="text-2xl font-bold text-gray-900 md:text-3xl lg:text-4xl">
            Embark on a Journey to Paradise – Discover the World’s Most
            Breathtaking Escapes
          </h2>

          <p className="text-base text-gray-600 md:text-lg">
            From serene tropical havens to sophisticated city escapes, indulge
            in our meticulously curated collection of luxury destinations.
            Whether you desire restful elegance, thrilling adventures, or
            immersive cultural encounters, discover the perfect stay crafted for
            an unforgettable experience.
          </p>
        </div>
        <HoverCard />
      </div>
      <WhyChooseUs />
      <div className="flex flex-col justify-between gap-5 px-4 pt-8 md:flex-row md:px-8 lg:px-16 xl:px-24">
        <h2 className="text-2xl font-bold text-gray-900 md:text-3xl">
          Premium Stays. Superior Quality.
        </h2>
        <p className="border-b-[3px] border-[#f4a261] pb-1 text-base text-gray-700">
          Discover the highest-rated hotels, handpicked for their exceptional
          service, comfort, and prime locations.
        </p>
      </div>
      <div className="z-20 grid grid-cols-1 gap-5 px-4 py-8 sm:grid-cols-2 md:grid-cols-3 md:px-8 lg:px-16 xl:px-24 3xl:grid-cols-4">
        {tickets.slice(0, visibleCount).map((ticket, idx) => (
          <NftCard
            key={idx}
            title={ticket.title}
            assigned_to={ticket.assigned_to}
            status={ticket.status}
            image={ticket.image}
            created_at={ticket.created_at}
          />
        ))}
      </div>

      {visibleCount < tickets.length && (
        <div className="my-4 text-center">
          <button
            onClick={handleViewMore}
            className="rounded-full bg-brand-800 px-6 py-2 text-white transition hover:bg-indigo-700"
          >
            View More
          </button>
        </div>
      )}

      <section className="relative h-[80vh] w-full">
        {/* Background Image */}
        <img
          src={Bg_Image} // replace with your image path or import
          alt="Luxury Retreat"
          className="absolute inset-0 z-0 h-full w-full object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 z-10 bg-black bg-opacity-20" />

        {/* Content */}
        <div className="relative z-20 flex h-full items-center justify-center px-4 text-center text-white md:px-8">
          <div className="max-w-3xl">
            <h1 className="text-3xl font-bold">
              Your Dream Stay Awaits – Start Your Journey Today !
            </h1>
            <p className="mt-4 text-lg text-gray-200 sm:text-xl">
              From breathtaking beach resorts to charming city escapes, your
              perfect getaway is just a click away. Find the best hotels at
              unbeatable prices and book with ease. Let your next adventure
              begin with Makku!
            </p>
            <button className="mt-6 rounded-full border-2 border-white px-6 py-2 text-white transition hover:bg-white hover:text-black">
              Find Your Stay
            </button>
          </div>
        </div>
      </section>
      <Testimonial />
    </>
  );
};

export default Home;
